/*
 * サブシステム名：受注
 * 機能名：受付一覧
 */
import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdCodeTextBox from '@/components/DdCodeTextBox.vue'
import DdDateBox from '@/components/DdDateBox'
import DdTextBox from '@/components/DdTextBox'
import DdDropDown from '@/components/DdDropDown'
import DdCheckbox from '@/components/DdCheckbox'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import validators from '@/rahmen/validators'
// import date from '@/ddv2.library/date'

export default {
  name: 'uketsukeList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {},
    headersJininList: header.mstJininHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0,
    page: 1,
    isLoading: false
  }),
  components: {
    DdSubHeader,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdTextBox,
    DdCodeTextBox,
    DdDateBox,
    DdDropDown,
    DdCheckbox
  },
  watch: {
    'conditions.zenjitsuSagyoKanryoFlg': function () {
      if (this.conditions.zenjitsuSagyoKanryoFlg) {
        var date = new Date()
        const zenjitsu = filter.dateFormatter(new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1))
        this.conditions.sagyoStartYmdString = zenjitsu
        this.conditions.sagyoEndYmdString = zenjitsu
      }
    },
    'conditions.hacchusakiId': function () {
      if (!this.isLoading) this.conditions.sagyoTantoshaId = null
    }
  },
  computed: {
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        // 表示フォーマット編集
        const elem2 = { ...elem }
        elem2.juchuYmdDisp = elem.juchuYmd ? filter.dateFormatter(elem.juchuYmd) : ''
        elem2.iraiDaisuDisp = elem.iraiDaisu === null || elem.iraiDaisu === undefined ? '' : filter.numericFormatter(elem.iraiDaisu)
        elem2.sagyoNaiyoKakuteiYmdDisp = elem.sagyoNaiyoKakuteiYmd ? filter.dateFormatter(elem.sagyoNaiyoKakuteiYmd) : ''
        elem2.unchinCheckYmdDisp = elem.unchinCheckYmd ? filter.dateFormatter(elem.unchinCheckYmd) : ''
        elem2.hatsuchiYmdDisp = elem.hatsuchiYmd ? filter.dateFormatter(elem.hatsuchiYmd) : ''
        elem2.chakuchiYmdDisp = elem.chakuchiYmd ? filter.dateFormatter(elem.chakuchiYmd) : ''
        elem2.seikyuYoteiYmdDisp = elem.seikyuYoteiYmd ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
        elem2.mitsumoriSagyoKingakuKeiDisp = elem.mitsumoriSagyoKingakuKei === null || elem.mitsumoriSagyoKingakuKei === undefined ? '' : filter.numericFormatter(elem.mitsumoriSagyoKingakuKei)
        elem2.mitsumoriBuzaiKingakuKeiDisp = elem.mitsumoriBuzaiKingakuKei === null || elem.mitsumoriBuzaiKingakuKei === undefined ? '' : filter.numericFormatter(elem.mitsumoriBuzaiKingakuKei)
        elem2.mitsumoriKingakuKeiDisp = elem.mitsumoriKingakuKei === null || elem.mitsumoriKingakuKei === undefined ? '' : filter.numericFormatter(elem.mitsumoriKingakuKei)
        elem2.seikyuSagyoKingakuKeiDisp = elem.seikyuSagyoKingakuKei === null || elem.seikyuSagyoKingakuKei === undefined ? '' : filter.numericFormatter(elem.seikyuSagyoKingakuKei)
        elem2.seikyuBuzaiKingakuKeiDisp = elem.seikyuBuzaiKingakuKei === null || elem.seikyuBuzaiKingakuKei === undefined ? '' : filter.numericFormatter(elem.seikyuBuzaiKingakuKei)
        elem2.seikyuKingakuKeiDisp = elem.seikyuKingakuKei === null || elem.seikyuKingakuKei === undefined ? '' : filter.numericFormatter(elem.seikyuKingakuKei)
        elem2.shiharaiKingakuKeiDisp = elem.shiharaiKingakuKei === null || elem.shiharaiKingakuKei === undefined ? '' : filter.numericFormatter(elem.shiharaiKingakuKei)
        return elem2
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isCreateButtonDisp () {
      return this.modeKengen >= 1
    },
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      jininList: 'DDMasters/mstJinin',
      shubetsuList: 'DDMasters/mstShubetsu',
      loginUserId: 'users/userId'
    }),
    // 得意先
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.tokuisakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 発注先
    filteredHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return (elem.hacchusakiFlg === true || elem.torihikisakiBunruiKbn1 === '02') && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 受付担当者
    filteredUketsukeTantoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        const jisha = this.torihikisakiList.filter(elem2 => elem2.torihikisakiBunruiKbn1 === '02')
        if (!jisha) {
          return false
        }
        return jisha.some(elem2 => elem2.torihikisakiCd === elem.shanaiBiko3) && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    // 作業担当者
    filteredSagyoTantoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        const sagyoIraisaki = this.filteredHacchusakiList.find(elem2 => elem2.id === this.conditions.hacchusakiId)
        if (!sagyoIraisaki) {
          return false
        }
        return elem.shanaiBiko3 === sagyoIraisaki.torihikisakiCd && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    // 種別マスタ：伝票種別
    filteredGenreSbt () {
      var x = this.sbtListFilterForDropDownItem(this.shubetsuList, 'TGS003')
      return x
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'mstjinin', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('TGRCOD0010.defineHeaderPromise')
            self.headers = [
              { text: '', value: 'jissekiMikakuninFlg', class: 'px-0', align: 'center' },
              { text: '作業予定日FROM', value: 'hatsuchiYmdDisp', align: 'center' },
              { text: '作業予定日TO', value: 'chakuchiYmdDisp', align: 'center' },
              { text: '客先注文番号', value: 'chumonNo' },
              { text: '得意先コード', value: 'tokuisakiCd' },
              { text: '得意先名称', value: 'tokuisakiNm' },
              { text: '取付先', value: 'toritsukesaki' },
              { text: '営業所', value: 'denpyoBiko1' },
              { text: '作業区分', value: 'sagyoKbnNm' },
              { text: '依頼台数', value: 'iraiDaisu' },
              { text: '受付担当者', value: 'uketsukeTantoshaNm' },
              { text: '受付日', value: 'juchuYmdDisp', align: 'center' },
              { text: '自社管理番号', value: 'jishaDenpyoNo' },
              { text: '注文ステータス', value: 'chumonStatus' },
              { text: '請求ランク', value: 'seikyuRankNm' },
              { text: '作業内容確定', value: 'sagyoNaiyoKakuteiFlgString', align: 'center' },
              { text: '作業内容確定担当者', value: 'sagyoNaiyoKakuteiTantoshaNm' },
              { text: '作業内容確定日', value: 'sagyoNaiyoKakuteiYmdDisp', align: 'center' },
              { text: '請求確定', value: 'unchinKakuteiFlgString', align: 'center' },
              { text: '請求確定担当者', value: 'unchinCheckTantoshaNm' },
              { text: '請求確定日', value: 'unchinCheckYmdDisp', align: 'center' },
              { text: '請求止め', value: 'seikyuTomeFlgString', align: 'center' },
              { text: '連携データ作成', value: 'seikyuZumiFlgString', align: 'center' },
              { text: '連携データ作成日', value: 'seikyuYoteiYmdDisp', align: 'center' },
              { text: 'ジャンル', value: 'genreNm' },
              { text: '担当者', value: 'denpyoBiko2' },
              { text: '電話番号', value: 'denpyoBiko3' },
              { text: '取付先 郵便番号', value: 'toritsukesakiYubinNo' },
              { text: '取付先 住所1', value: 'toritsukesakiJusho1' },
              { text: '取付先 住所2', value: 'toritsukesakiJusho2' },
              { text: '電話番号2', value: 'toritsukesakiJusho3' },
              { text: '作業場所 郵便番号', value: 'sagyobashoYubinNo' },
              { text: '作業場所 住所1', value: 'sagyobashoJusho1' },
              { text: '作業場所 住所2', value: 'sagyobashoJusho2' },
              { text: '作業場所 住所3', value: 'sagyobashoJusho3' },
              { text: '取付先備考', value: 'hanyoBiko' },
              { text: '商品', value: 'shohinNm' },
              { text: '受付備考', value: 'biko' },
              { text: '見積差分備考', value: 'mitsumoriSabunBiko' },
              { text: '宛名', value: 'denpyoBiko4' },
              { text: '件名', value: 'kenmeiNm' },
              { text: '納入場所', value: 'denpyoBiko5' },
              { text: '有効期限', value: 'yukokigenNm' },
              { text: '見積備考', value: 'mitsumoriBiko' },
              { text: '会社コード', value: 'denpyoBiko6' },
              { text: 'IPアドレス', value: 'denpyoBiko7' },
              { text: 'ポート番号', value: 'denpyoBiko8' },
              { text: '見積作業金額計', value: 'mitsumoriSagyoKingakuKeiDisp', align: 'end' },
              { text: '見積部材金額計', value: 'mitsumoriBuzaiKingakuKeiDisp', align: 'end' },
              { text: '見積金額計', value: 'mitsumoriKingakuKeiDisp', align: 'end' },
              { text: '請求作業金額計', value: 'seikyuSagyoKingakuKeiDisp', align: 'end' },
              { text: '請求部材金額計', value: 'seikyuBuzaiKingakuKeiDisp', align: 'end' },
              { text: '請求金額計', value: 'seikyuKingakuKeiDisp', align: 'end' },
              { text: '支払金額計', value: 'shiharaiKingakuKeiDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              juchuStartYmdString: null,
              juchuEndYmdString: null,
              iraiStartYmdString: null,
              iraiEndYmdString: null,
              sagyoYoteiStartYmdString: null,
              sagyoYoteiEndYmdString: null,
              sagyoStartYmdString: null,
              sagyoEndYmdString: null,
              tokuisakiId: null,
              denpyoHanyoSbt3: null,
              uketsukeTantoshaId: self.loginUserId,
              hacchusakiId: null,
              sagyoTantoshaId: null,
              zenjitsuSagyoKanryoFlg: false,
              sagyoJunbiFlg: true,
              sagyoKanryoMachiFlg: true,
              sagyoKanryoFlg: true,
              seikyuKakuteiFlg: true
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('TGRCOD0010.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          if (Object.keys(c).length !== 0) {
          }
          console.log('TGRCOD0010.savedInputRestorePromise', self.conditions)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('TGRCOD0010.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.isLoading = true
              self.conditions = c.cache.value.conditions || {}
              self.$nextTick(() => { self.isLoading = false })
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('TGRCOD0010.restoreViewPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              this.isLoading = true
              this.conditions = c.cache.value.conditions || {}
              this.searchText = c.cache.value.searchText || ''
              this.rows = c.cache.value.rows || []
              this.$nextTick(() => { this.isLoading = false })
            }
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCTgrcod0011/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            // const d = new Date()
            this.conditions = {
              juchuStartYmdString: null,
              juchuEndYmdString: null,
              iraiStartYmdString: null,
              iraiEndYmdString: null,
              sagyoYoteiStartYmdString: null,
              sagyoYoteiEndYmdString: null,
              sagyoStartYmdString: null,
              sagyoEndYmdString: null,
              tokuisakiId: null,
              denpyoHanyoSbt3: null,
              uketsukeTantoshaId: this.loginUserId,
              hacchusakiId: null,
              sagyoTantoshaId: null,
              zenjitsuSagyoKanryoFlg: false,
              sagyoJunbiFlg: true,
              sagyoKanryoMachiFlg: true,
              sagyoKanryoFlg: true,
              seikyuKakuteiFlg: true
            }
            this.searchText = ''
            this.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: e.trJuchuMeisaiId })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/vwCTgrcod0011/download', this.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '案件一覧_' + ts + '.csv'
          elem.click()
        })
    },
    onSharyoCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/vwCTgrcod0011/sharyoDownload', this.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('sharyoDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '案件_作業依頼_車両明細_' + ts + '.csv'
          elem.click()
        })
    },
    onBuzaiCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/vwCTgrcod0011/buzaiDownload', this.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('buzaiDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '部材明細_' + ts + '.csv'
          elem.click()
        })
    },
    onMitsumoriCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/vwCTgrcod0011/mitsumoriDownload', this.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('mitsumoriDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '見積明細_' + ts + '.csv'
          elem.click()
        })
    },
    searchValidate: function () {
      console.log('searchValidate')
      // 受付日FROM TOの大小チェック
      var msg = validators.compareDate(this.conditions.juchuStartYmdString, this.conditions.juchuEndYmdString)
      if (msg !== undefined) {
        this.$refs.juchuStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.juchuEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      // 依頼日FROM TOの大小チェック
      msg = validators.compareDate(this.conditions.iraiStartYmdString, this.conditions.iraiEndYmdString)
      if (msg !== undefined) {
        this.$refs.iraiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.iraiEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      // 作業予定日FROM TOの大小チェック
      msg = validators.compareDate(this.conditions.sagyoYoteiStartYmdString, this.conditions.sagyoYoteiEndYmdString)
      if (msg !== undefined) {
        this.$refs.sagyoYoteiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.sagyoYoteiEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      // 作業日FROM TOの大小チェック
      msg = validators.compareDate(this.conditions.sagyoStartYmdString, this.conditions.sagyoEndYmdString)
      if (msg !== undefined) {
        this.$refs.sagyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.sagyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }

      return true
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    }
  }
}
